import whoweare from"../assets/img/about/whoweare.png"

function About(){
    return (
            <section className="py-5">
            <div className="container">
                <div className="row gx-4 align-items-center">
                <div className="col-md-6 order-2 order-lg-1">
                    <div className="me-md-2 me-lg-5 text-center mt-5 mt-md-0">
                    <span className="text-muted">🌟 Our Story</span>
                    <h2 className="display-5 fw-bold">Empowering Innovation in Chip Design</h2>
                    <p className="lead">
                        We are a passionate team dedicated to making cutting-edge chip design accessible to everyone. 
                        By curating powerful open-source tools, we empower engineers, researchers, and innovators to push the boundaries of technology—freely and without limitations.
                    </p>    
                    </div>
                </div>
                <div className="col-md-6 order-1 order-lg-2">
                    <div className="ms-md-2 ms-lg-5">
                    <img
                        className="img-fluid rounded-3"
                        src={whoweare}
                        alt= "Who are we?"
                    />
                    </div>
                </div>
                </div>
            </div>
</section>
    )
}

export default About